import React, { useEffect } from 'react';
import { IProcessManager } from '../../Interfaces/IProcessManager';
import {
  IProcessManagerAutomation,
  IProcessManagerAutomationEmail,
  IProcessManagerAutomationEmailToExternal,
  IProcessManagerAutomationEmailToLegalClient,
  processManagerAutomationEmailSchema,
  processManagerAutomationEmailToExternalSchema,
  processManagerAutomationEmailToLegalClientSchema,
} from '../../Interfaces/IProcessManagerAutomation';
import { Grid, MenuItem, TextField } from '@mui/material';
import { CustomEditor } from '../../core/CustomEditor';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { ILegalClient } from '../../Interfaces/ILegalClient';
import { CustomeTextField } from '../../generic/CustomeTextField';

interface IProps {
  processManager: IProcessManager;
  editAutomation: IProcessManagerAutomation;
  setEditAutomation: Function;
  //
  legalClients: ILegalClient[];
  //
  setIsValidatedChild: Function;
}

function isEmailAutomation(
  data: IProcessManagerAutomation['data']
): data is IProcessManagerAutomationEmail {
  return processManagerAutomationEmailSchema.safeParse(data).success;
}
function isEmailAutomationExternal(
  data: IProcessManagerAutomation['data']
): data is IProcessManagerAutomationEmailToExternal {
  return processManagerAutomationEmailToExternalSchema.safeParse(data).success;
}
function isEmailAutomationLegalClients(
  data: IProcessManagerAutomation['data']
): data is IProcessManagerAutomationEmailToLegalClient {
  return processManagerAutomationEmailToLegalClientSchema.safeParse(data)
    .success;
}

export const EditPMAutomationEmail: React.FC<IProps> = ({
  processManager,
  editAutomation,
  setEditAutomation,
  legalClients,
  setIsValidatedChild,
}) => {
  useEffect(() => {
    if (isEmailAutomation(editAutomation.data)) {
      setIsValidatedChild(
        editAutomation.data.Subject !== '' &&
          ((isEmailAutomationExternal(editAutomation.data) &&
            editAutomation.data.Receiver !== '') ||
            (isEmailAutomationLegalClients(editAutomation.data) &&
              editAutomation.data.idLegalClient > 0))
      );
    }
  }, [editAutomation.data]);

  if (!isEmailAutomation(editAutomation.data)) {
    return <>Fehler: Ungültige Datenstruktur!</>;
  }

  return (
    <>
      {isEmailAutomationExternal(editAutomation.data) && (
        <Grid item sm={6}>
          <TextField
            label='Empfänger'
            size='small'
            value={editAutomation.data.Receiver}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setEditAutomation({
                ...editAutomation,
                data: {
                  ...editAutomation.data,
                  Receiver: event.target.value,
                },
              })
            }
            fullWidth
            required
          />
        </Grid>
      )}
      {isEmailAutomationLegalClients(editAutomation.data) && (
        <Grid item sm={6}>
          <CustomeTextField
            attr='idLegalClient'
            label='Mandant'
            object={
              editAutomation.data.idLegalClient === -1
                ? { ...editAutomation.data, idLegalClient: null }
                : editAutomation.data
            }
            setObject={(
              updatedObject: IProcessManagerAutomationEmailToLegalClient
            ) => setEditAutomation({ ...editAutomation, data: updatedObject })}
            type='select'
            null={editAutomation.data.idLegalClient < 0}
          >
            {legalClients.map(legalClient => (
              <MenuItem
                key={`email-to-${legalClient.idLegalClient}`}
                value={legalClient.idLegalClient}
              >
                {legalClient.FirstName} {legalClient.LastName}
              </MenuItem>
            ))}
          </CustomeTextField>
        </Grid>
      )}

      <Grid item sm={6}>
        <CustomeTextField
          label='Betreff'
          attr='Subject'
          object={editAutomation.data}
          setObject={(obj: any) =>
            setEditAutomation({
              ...editAutomation,
              data: obj,
            })
          }
          type='string'
          size='small'
          required
          maxLength='md'
        />
      </Grid>

      <Grid item sm={12}>
        <CustomEditor
          txt={editAutomation.data.Body}
          setTxt={(txt: string) =>
            setEditAutomation({
              ...editAutomation,
              data: {
                ...editAutomation.data,
                Body: txt,
              },
            })
          }
        />
      </Grid>
    </>
  );
};
